import {AnimatePresence, motion} from 'framer-motion';
import {ReactNode} from 'react';

type Props = {
  children: ReactNode;
};
export default function AnimationWrapper({children}: Props) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1, transition: {duration: 0.3}}}
        exit={{opacity: 0, transition: {duration: 1}}}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
